var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-content-header", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "top" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.itemid
                    ? _c("node-element-local-tasks", {
                        attrs: { itemid: _vm.itemid },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notpublished
                    ? _c("div", { staticClass: "messages warning" }, [
                        _vm._v("\n          Not published\n        "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-body" },
        [
          _vm.hasBody
            ? _c("page-content-wysiwg-content", { attrs: { item: _vm.item } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.timelinePoints.length > 0
        ? _c(
            "b-container",
            { staticClass: "timeline-section" },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("div", { staticClass: "timeline-top" }),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "timeline" },
                      _vm._l(
                        _vm.timelinePoints,
                        function (timelineItem, index) {
                          return _c("li", { key: index }, [
                            _c("div", { staticClass: "timeline-panel" }, [
                              _c(
                                "div",
                                { staticClass: "timeline-badge-container" },
                                [_c("div", { staticClass: "timeline-badge" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "timeline-panel-inner" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "timeline-preview" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "timeline-step" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "larger" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getYear(timelineItem)
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "smaller" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getMonth(timelineItem)
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.getDay(timelineItem)
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasImage(timelineItem)
                                        ? _c("AImage", {
                                            attrs: {
                                              img: _vm.getImage(timelineItem),
                                              ratio: "16-9",
                                              cover: "",
                                              preset: "timelinepagepoint",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "timeline-body" }, [
                                    _c("h3", { staticClass: "title" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.getTitle(timelineItem)) +
                                          "\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.getDescription(timelineItem)
                                      ? _c("div", {
                                          staticClass: "description",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getDescription(timelineItem)
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getLinkUrl(timelineItem)
                                      ? _c(
                                          "div",
                                          { staticClass: "timeline-action" },
                                          [
                                            _vm.isRouterlinkComponent(
                                              timelineItem
                                            )
                                              ? _c(
                                                  "router-link",
                                                  {
                                                    staticClass: "action-btn",
                                                    attrs: {
                                                      to: {
                                                        path: _vm.getLinkUrl(
                                                          timelineItem
                                                        ),
                                                      },
                                                      title:
                                                        _vm.getLinkTitle(
                                                          timelineItem
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getLinkTitle(
                                                            timelineItem
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass: "action-btn",
                                                    attrs: {
                                                      href: _vm.$options.filters.toUrl(
                                                        _vm.getLinkUrl(
                                                          timelineItem
                                                        )
                                                      ),
                                                      title:
                                                        _vm.getLinkTitle(
                                                          timelineItem
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getLinkTitle(
                                                            timelineItem
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "timeline-bottom" }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("page-content-creator", {
                    attrs: { itemid: _vm.itemid, pos: "bottom" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }